// extracted by mini-css-extract-plugin
export var allPartners = "index-module--allPartners--lIzlm";
export var emptyLink = "index-module--emptyLink--iXQc1";
export var emptyList = "index-module--emptyList--tFXdS";
export var fullLink = "index-module--fullLink--ESdFm";
export var image = "index-module--image--qTUXt";
export var link = "index-module--link--TQvf6";
export var moreButton = "index-module--moreButton--bzD1k";
export var partnerCard = "index-module--partnerCard--D944X";
export var partnerItem = "index-module--partnerItem--glUxv";
export var partnerLink = "index-module--partnerLink--aMQrc";
export var partners = "index-module--partners--oRfm8";
export var select = "index-module--select--NjQn0";
export var selectItem = "index-module--selectItem--3wb0G";
export var selectOption = "index-module--selectOption--Ms3Ii";